import mitt from "mitt";
import type { PropsWithChildren } from "react";
import { useMemo } from "react";
import { LOGS } from "../../../utils/logs/categories";
import { logger } from "../../../utils/logs/core";
import { EventsProviderContext } from "../hooks/use-events-context";
import { AppEvents, EventBus } from "../types/events";

type EventsProviderProps = PropsWithChildren<{}>;

const emitter = mitt<AppEvents>();

export function EventsProvider({ children }: EventsProviderProps) {
    const memoizedValue = useMemo<EventBus>(
        () => ({
            emit: (type, event) => {
                logger.info(LOGS.Events, `[Event] ${type}`, event);

                event !== undefined
                    ? emitter.emit(type, event)
                    : (emitter.emit as any)(type);
            },
            on: (type, handler) => emitter.on(type, handler),
            off: (type, handler) => emitter.off(type, handler),
        }),
        [],
    );

    return (
        <EventsProviderContext.Provider value={memoizedValue}>
            {children}
        </EventsProviderContext.Provider>
    );
}
